
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import Modal from "../../../../common/src/components/Modal.vue";
import ActionButton from "../../../../common/src/components/ActionButton.vue";
import { FirstTimeDashboardVisitSidebarStore } from "./FirstTimeDashboardVisitSidebarStore";
// import { AuthStore } from "../../../../common/src/stores/AuthStore";

@Component({
    components: { Modal, ActionButton },
    directives: {},
})
export default class FirstTimeDashboardVisitSideBar extends Vue {
    @Inject("container") readonly container!: Container;
    firstTimeDashboardVisitSidebarStore: FirstTimeDashboardVisitSidebarStore = this.container.get(
        FirstTimeDashboardVisitSidebarStore,
    );
    // authStore: AuthStore = this.container.get(AuthStore);

    close() {
        this.firstTimeDashboardVisitSidebarStore.close();
    }
}
